var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { authActions } from './authActions';
import { E_AUTH_ACTION_TYPES } from './actionTypes';
import { KeycloakEntity } from 'src/shared/KeycloakEntity';
import { getRealm } from 'src/redux/core/coreSelectors';
import { authServices } from 'src/services/auth/authServices';
import { E_PERMISSION_KEY } from 'src/services/auth/types/permissionsTypes';
var PERMISSIONS_KEYS = [
    E_PERMISSION_KEY.CASE_GLOBAL_VIEW_DISPLAY_MRZ_CHECK_MODULE,
    E_PERMISSION_KEY.CASE_GLOBAL_VIEW_DISPLAY_UPLOAD_MODULE,
    E_PERMISSION_KEY.CASE_GLOBAL_VIEW_DISPLAY_COMMENT_MODULE,
    E_PERMISSION_KEY.USER_MANAGEMENT_VIEW,
    E_PERMISSION_KEY.USER_MANAGEMENT_IMPORT,
    E_PERMISSION_KEY.CASE_SEARCH_FILTERS_VIEW,
    E_PERMISSION_KEY.CASE_SEARCH_RESULTS_VIEW,
    E_PERMISSION_KEY.CASE_SEARCH_USER_CUSTOM_SEARCH_PERFORM,
    E_PERMISSION_KEY.CASE_SEARCH_AUTO_PLAY_PERFORM,
];
function fetchPermissions() {
    var realm, callAPI, _a, payload, status, error, errorMessage;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getRealm)];
            case 1:
                realm = _b.sent();
                return [4 /*yield*/, call(function () { return authServices.fetchPermissions(realm, { permissionKeys: PERMISSIONS_KEYS }); })];
            case 2:
                callAPI = (_b.sent()).callAPI;
                return [4 /*yield*/, callAPI()];
            case 3:
                _a = _b.sent(), payload = _a.payload, status = _a.status, error = _a.error, errorMessage = _a.errorMessage;
                if (!error) return [3 /*break*/, 4];
                console.log('Error during fetching permissions : ', errorMessage);
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, put(authActions.fetchPermissionsSucceeded(payload.permissions))];
            case 5:
                _b.sent();
                _b.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}
function fetchGroups() {
    var realm, callAPI, _a, payload, status, error, errorMessage;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getRealm)];
            case 1:
                realm = _c.sent();
                return [4 /*yield*/, call(function () { return authServices.fetchGroups(realm); })];
            case 2:
                callAPI = (_c.sent()).callAPI;
                return [4 /*yield*/, callAPI()];
            case 3:
                _a = _c.sent(), payload = _a.payload, status = _a.status, error = _a.error, errorMessage = _a.errorMessage;
                if (!error) return [3 /*break*/, 4];
                console.log('Error during fetching teams : ', errorMessage);
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, put(authActions.fetchGroupsSucceeded(((_b = payload._embedded) === null || _b === void 0 ? void 0 : _b.groupList) || []))];
            case 5:
                _c.sent();
                _c.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}
function logout() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                KeycloakEntity.logout();
                return [4 /*yield*/, put(authActions.logoutSucceeded())];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export function authSagas() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(E_AUTH_ACTION_TYPES.USER_LOGOUT_REQUESTED, logout)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(E_AUTH_ACTION_TYPES.FETCH_PERMISSIONS_REQUESTED, fetchPermissions)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(E_AUTH_ACTION_TYPES.FETCH_GROUP_REQUESTED, fetchGroups)];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
